if (!customElements.get('order-form')) {
  class OrderForm extends HTMLElement {
    static define(tag = 'order-form') {
      customElements.define(tag, this)
    }

    // shadowRoot = this.attachShadow({ mode: "open" })
    #selectAllCheckbox = null
    #allProductCheckboxes = []
    #priceTotalElement = null
    #addToCartBtn = null

    connectedCallback() {
      this.#selectAllCheckbox = this.querySelector('.order-form-select-all')
      this.#allProductCheckboxes = this.querySelectorAll('.order-form-product:enabled')
      this.#priceTotalElement = this.querySelector('.order-form-total')
      this.#addToCartBtn = this.querySelector('.order-form-add-to-cart')

      this.#selectAllCheckbox.addEventListener('change', () => this.selectAllChanged())
      this.#allProductCheckboxes.forEach((productCheckbox) =>
        productCheckbox.addEventListener('change', () => this.recalculateTotal()))
      this.#addToCartBtn.addEventListener('click', () => this.addToCart())

      // Handles back / forward button cases where boxes are checked, but total is still $0
      setTimeout(() => this.recalculateTotal(), 1000)
    }

    selectAllChanged() {
      this.#allProductCheckboxes.forEach((checkbox) => {
        if (this.#selectAllCheckbox.checked !== checkbox.checked) {
          checkbox.checked = this.#selectAllCheckbox.checked
        }
      })

      this.recalculateTotal()
    }

    allSelectedCheckboxes() {
      return this.querySelectorAll('.order-form-product[data-variant-price-cents]:checked')
    }

    recalculateTotal() {
      const dollar = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
      const totalPriceCents =
        [...this.allSelectedCheckboxes()]
          .reduce((acc, item) => acc + parseInt(item.dataset.variantPriceCents || 0), 0)

      this.#priceTotalElement.innerHTML = dollar.format(totalPriceCents / 100)
    }

    addToCart() {
      let formData = {
        sections_url: window.location.pathname,
        sections: 'main-cart,cart-drawer,cart-bubble',
        items:
          [...this.allSelectedCheckboxes()]
            .map((item) => item.dataset.variantId)
            .map((id) => ({ id, quantity: 1 }))
      }

      if (formData.items.length === 0) {
        return
      }

      fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          return response.json();
        })
        .then((json) => this.renderContents(json))
        .catch((error) => {
          console.error('Error:', error);
        })
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }))

      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    disconnectedCallback() {
      this.#selectAllCheckbox.removeEventListener('change')
      this.#allProductCheckboxes.forEach((productCheckbox) =>
        productCheckbox.removeEventListener('change'))
    }
  }

  OrderForm.define()
}
